import { LocalizedLink } from "../../i18n/LocalizedLink";
import { useLocale } from "../../i18n/useLocale";
import { useVisualGuides } from "../../i18n/useVisualGuides";
import { GuideStepList } from "./GuideStep";
import {
  SketchExportMenu,
  SketchPrintDialog,
  SketchWerkplanSettings,
  SketchWerkplanShop,
} from "./GuideSketches";

const VISUALS = [
  <SketchExportMenu key="open" activeItem="pdf" />,
  <SketchWerkplanSettings key="settings" />,
  <SketchWerkplanShop key="shop" />,
  <SketchPrintDialog key="print" />,
];

export function WerkplanGuideVisual() {
  const { display } = useLocale();
  const visualGuides = useVisualGuides();
  const guide = visualGuides.werkplanExport;

  return (
    <>
      <GuideStepList intro={guide.intro} steps={guide.steps} visuals={VISUALS} />
      {guide.sections?.map((section) => (
        <section className="info-page-section" key={section.heading}>
          <h2>{section.heading}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </section>
      ))}
      <p className="guide-related">
        {display.t("web.guides.related.werkplanBefore")}{" "}
        <LocalizedLink to="/handleiding/zaagvolgorde-controleren">
          {display.t("web.guides.nav.cutSimulator")}
        </LocalizedLink>
        . {display.t("web.guides.related.werkplanAfter")}{" "}
        <LocalizedLink to="/">{display.t("web.guides.related.planner")}</LocalizedLink>{" "}
        {display.t("web.guides.related.werkplanOrRead")}{" "}
        <LocalizedLink to="/handleiding/hoe-het-werkt">{display.t("web.guides.nav.how")}</LocalizedLink>.
      </p>
    </>
  );
}
